import { render, staticRenderFns } from "./lkuKoranJurusan.vue?vue&type=template&id=9fbdec88"
import script from "./lkuKoranJurusan.vue?vue&type=script&lang=js"
export * from "./lkuKoranJurusan.vue?vue&type=script&lang=js"
import style0 from "./lkuKoranJurusan.vue?vue&type=style&index=0&id=9fbdec88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports